var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmapNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1267 12.0695C16.8465 12.2102 16.7305 12.5638 16.8746 12.8223C16.9106 12.8869 18.3873 14.4343 20.1522 16.263C21.917 18.0879 23.4458 19.6809 23.5458 19.7987L23.7339 20.0154L23.6379 20.1295C23.5898 20.1903 22.0611 21.7719 20.2442 23.65C18.4273 25.5243 16.9226 27.0945 16.8946 27.1401C16.7345 27.4214 16.8385 27.7902 17.1187 27.9233C17.3508 28.0373 17.5189 28.0259 17.739 27.8777C17.839 27.813 19.4638 26.163 21.3487 24.2203C23.2377 22.2737 24.8545 20.6047 24.9505 20.5097C25.1866 20.2663 25.2386 20.0724 25.1386 19.8063C25.0746 19.6276 24.6944 19.2208 21.4928 15.9246C19.5319 13.902 17.839 12.1874 17.739 12.119C17.5269 11.9783 17.3388 11.9631 17.1267 12.0695Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapNext);
export default __webpack_public_path__ + "static/media/roadmap-next.e146375ff873cfd43488f9ef07ae2ca5.svg";
export { ForwardRef as ReactComponent };